import { Component, OnInit } from '@angular/core';
import { ApplicationViewsService } from '../../ApplicationViews/Services/application-views.services';
import { MaintenanceService } from '../../services/maintenance.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ViewInfoResource } from 'src/app/client-api.service';
import { map, tap } from 'rxjs/operators';
import { PanelSize } from 'src/app/shared/tcc-ui/simple-panel/models';

@Component({
  selector: 'app-ledger-view-info-upsert',
  templateUrl: './ledger-view-info-upsert.component.html',
  styleUrls: ['./ledger-view-info-upsert.component.scss']

})
export class LedgerViewInfoUpsertComponent implements OnInit {

  addOrEdit: 'add' | 'edit';
  currentId = 0;
  currentViewInfo: ViewInfoResource | undefined;
  duplicateKey = false;
  readonly ledgers$ = this.appViewsServices.ledgers$;
  panalSize: PanelSize = 'large';
  viewInfos$ = this.appViewsServices.viewInfos$;
  viewInfos: ViewInfoResource[] | undefined;  

  viewInfoFormGroup = new FormGroup({
    viewId: new FormControl(0, { nonNullable: true }),    
    name: new FormControl('', { nonNullable: true, validators: Validators.required }),
    ledgerId: new FormControl(0, { nonNullable: true })
  });
  state: 'initializing' | 'loading' | 'ready' | 'saving';  

  constructor(private appViewsServices: ApplicationViewsService,
              private maintenanceService: MaintenanceService,
              private activatedRoute: ActivatedRoute,
              private router: Router) {
    this.state = 'initializing';  
    this.addOrEdit = 'edit';
  }

  ngOnInit(): void {
    this.state = 'loading';  
    this.viewInfos$.pipe(
      map(v => {
        this.viewInfos = v;        
        return v;
      }),
      tap(() => {this.state = 'ready'})
    ).subscribe();

    this.appViewsServices.setViewInfos();
    this.appViewsServices.setLedgers();

    this.activatedRoute.params.subscribe(routeParam => {
      this.currentId =  routeParam['id'];      
      if(routeParam['id'] !== '0') {
        this.addOrEdit = 'edit';        
        this.getViewInfo(this.currentId);        
        this.state = 'ready';        
      }
      else {
        this.addOrEdit = 'add';        
        this.viewInfoFormGroup.reset();        
        this.state = 'ready';        
      }
    });    
  }

  close() {
    this.maintenanceService.setMaintenanceComponenetPanelSize('large');
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent });
  }

  fieldChanged(elem: HTMLInputElement) {    
    
    return this.viewInfoFormGroup.get(elem.name)?.dirty;
  }

  getViewInfo(viewId: number) {
    this.state = 'loading';
    this.currentViewInfo = this.viewInfos?.find(v => v.viewId == viewId);
    this.viewInfoFormGroup.patchValue({
      viewId : this.currentViewInfo?.viewId,
      name: this.currentViewInfo?.name,
      ledgerId: this.currentViewInfo?.ledgerId
    })
  }

  isChanged(field: string) {
    return this.viewInfoFormGroup.get(field)?.dirty;
  }

  onSubmit() {

    if(this.addOrEdit === 'add') {
      this.viewInfoFormGroup.controls['viewId'].setValue(0); 
    }

    this.viewInfoFormGroup.controls['name'].enable();
    this.viewInfoFormGroup.controls['ledgerId'].enable();

    const viewInfoResource: ViewInfoResource = this.viewInfoFormGroup.getRawValue();

      this.appViewsServices.putViewInfo(viewInfoResource).subscribe(
        res => {
          this.appViewsServices.setViewInfos();
          this.close();
        },
        err => {
          alert('Error adding Application View!');
        });
  }
}
